import * as yup from 'yup';

import { TrlFormattedMessagePlain } from '»utils/i18n';

export const trlActivateUserValidation = () => {
  return yup.object().shape({
    passwordNova: yup
      .string()
      .required(TrlFormattedMessagePlain({ id: 'TRLT_UI-REQUIRED_FIELD' })),
    passwordConfirmar: yup
      .string()
      .oneOf(
        [yup.ref('passwordNova'), ''],
        TrlFormattedMessagePlain({ id: 'TRLT_UI-PASSWORD_MATCH' }),
      )
      .required(TrlFormattedMessagePlain({ id: 'TRLT_UI-REQUIRED_FIELD' })),
  });
};
